// extracted by css-extract-rspack-plugin
export default {"metadataContainer":"MetadataContainer-module__metadataContainer__CfTplLs"};